import React from 'react';
import {Outlet} from 'react-router-dom';
import classNames from 'classnames';
import {ErrorBoundary} from 'react-error-boundary';
import ErrorFallback from '../../../components/ErrorFallback';
import './shell.scss';
import MainHeader from '../../../components/main-header/main-header';
import MainFooter from '../../../components/main-footer/main-footer';
import {ErrorMessagesProvider} from '../error-messages-context';
import ErrorMessages from '../error-messages';

const CartShell = () => {
    const [menuFlag, setMenuFlag] = React.useState(false);
    const setMenuFlagCallback = React.useCallback((val) => setMenuFlag(val), []);
    
    return (
        <ErrorMessagesProvider>
            <div className='display-flex flex-direction-column cart cart-fullheight'>
                <MainHeader menuFlag={menuFlag} setMenuFlag={setMenuFlagCallback}/>
                <div className={classNames({'hide-small': menuFlag}, 'flex-1 display-flex flex-direction-column cart__content')}>
                    <ErrorBoundary {...{FallbackComponent: ErrorFallback}}>
                        <Outlet/>
                    </ErrorBoundary>
                </div>
                <div className='hide-small'>
                    <MainFooter/>
                </div>
            </div>
            <ErrorMessages/>
        </ErrorMessagesProvider>
    )
};

export default React.memo(CartShell);